<template>
    <div @click="openWhatsApp" class="whats-bottom-icon" :class="{ 'whats-preload': animateItem }">
        <span>
            <svg class="w-8 h-8 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="38" height="38" fill="none" viewBox="0 0 24 24">
                <path fill="#fff" fill-rule="evenodd"
                    d="M12 4a8 8 0 0 0-6.895 12.06l.569.718-.697 2.359 2.32-.648.379.243A8 8 0 1 0 12 4ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.96 9.96 0 0 1-5.016-1.347l-4.948 1.382 1.426-4.829-.006-.007-.033-.055A9.958 9.958 0 0 1 2 12Z"
                    clip-rule="evenodd" />
                <path fill="#fff"
                    d="M16.735 13.492c-.038-.018-1.497-.736-1.756-.83a1.008 1.008 0 0 0-.34-.075c-.196 0-.362.098-.49.291-.146.217-.587.732-.723.886-.018.02-.042.045-.057.045-.013 0-.239-.093-.307-.123-1.564-.68-2.751-2.313-2.914-2.589-.023-.04-.024-.057-.024-.057.005-.021.058-.074.085-.101.08-.079.166-.182.249-.283l.117-.14c.121-.14.175-.25.237-.375l.033-.066a.68.68 0 0 0-.02-.64c-.034-.069-.65-1.555-.715-1.711-.158-.377-.366-.552-.655-.552-.027 0 0 0-.112.005-.137.005-.883.104-1.213.311-.35.22-.94.924-.94 2.16 0 1.112.705 2.162 1.008 2.561l.041.06c1.161 1.695 2.608 2.951 4.074 3.537 1.412.564 2.081.63 2.461.63.16 0 .288-.013.4-.024l.072-.007c.488-.043 1.56-.599 1.804-1.276.192-.534.243-1.117.115-1.329-.088-.144-.239-.216-.43-.308Z" />
            </svg>
        </span>
    </div>
</template>
<script>
export default {
    data() {
        return {
            animateItem: true,
        };
    },
    methods: {
        openWhatsApp() {
            //const phoneNumber = '+201027857863'; 
            //const message = '.';
            const url = `https://wa.me/201027857863?text=${encodeURIComponent('.')}`;
            //const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
            window.open(url, '_blank');
        }
    },
    mounted() {
        setTimeout(() => {
            this.animateItem = false;
        }, 2000);
    },
};
</script>

<style lang="scss">
.whats-bottom-icon {
    background: #31b71a;
    position: fixed;
    width: 59px;
    height: 59px;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    bottom: 20px;
    left: 20px;

    &:hover {
        cursor: pointer;

        // Target the span directly inside the hovered .whats-bottom-icon
        >span {
            animation: rotate-center 0.4s 1 ease-in-out both;
        }
    }

}

.whats-preload {
    animation: icon-opacity 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
}

// Keyframes for rotate-center animation
@keyframes rotate-center {
    0% {
        transform: rotate(0);
    }

    100% {
        transform: rotate(360deg);
    }
}

// Keyframes for icon-opacity animation
@keyframes icon-opacity {
    0% {
        opacity: 0;
        transform: scale(0.8);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}
</style>